export default __webpack_public_path__ + "static/media/D5.8129e64c.gif";